import React, { ReactNode } from 'react';
import { FieldValues, Path, Control } from 'react-hook-form';
import { FACT_NAMES_STRING, FACT_NAMES_NUMERIC } from '@trnsact/trnsact-scorecard-sdk';
import { determineRuleType } from '../lib';

import { ConditionsFieldsTypes } from '../types';
import { StringFieldsByRule } from './StringFieldsByRule';
import { NumberFieldsByRule } from './NumberFieldsByRule';
import { BooleanFieldsByRule } from './BooleanFieldsByRule';

interface Props<FormValues extends FieldValues = FieldValues> {
  ruleType: string;
  name: Path<FormValues>;
  control: Control<FormValues>;
}

export const ConditionsFieldsByRuleTypeRHF = <FormValues extends FieldValues = FieldValues>({
  name,
  control,
  ruleType,
}: Props<FormValues>) => {
  const type = determineRuleType(ruleType as any);

  const renderFields: Record<ConditionsFieldsTypes, ReactNode> = {
    [ConditionsFieldsTypes.Boolean]: <BooleanFieldsByRule control={control} namePrefix={name} />,
    [ConditionsFieldsTypes.Number]: (
      <NumberFieldsByRule control={control} type={ruleType as FACT_NAMES_NUMERIC} namePrefix={name} />
    ),
    [ConditionsFieldsTypes.String]: (
      <StringFieldsByRule control={control} type={ruleType as FACT_NAMES_STRING} name={name} />
    ),
  };

  return <>{renderFields[type]}</>;
};
